import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import axios from 'axios'
import config from 'config'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { isGifUrl, isNativeIOS } from 'srcReact/helpers/utils'

export default function LinkPreview({
  data,
  containerCSS,
  linkCSS,
  previewCSS,
  height = '20rem',
  isGifLink,
  fromQuickMessenger
}) {
  const [links, setLinks] = useState([])
  const [imageUrls, setImageUrls] = useState([])
  const [descriptions, setDescriptions] = useState([])
  const [titles, setTitles] = useState([])
  const [siteNames, setSiteNames] = useState([])
  const [videos, setVideos] = useState([])
  const [videoTypes, setVideoTypes] = useState([])
  const [hasError, setHasError] = useState(false)
  const [isGifImages, setIsGifImages] = useState([])
  const [notValidImage, setNotValidImage] = useState(false)
  const apiKey = config.linkPreviewKey
  useEffect(() => {
    if (data) {
      // Disabled link preview in iOS
      if (isNativeIOS() && location.pathname.includes('/0/messenger')) {
        setLinks([])
      } else {
        let snippet = document.createElement('div')
        snippet.innerHTML = data
        const aTags = snippet.getElementsByTagName('a')
        let aLinks = []
        if (aTags.length > 0) {
          for (let item of aTags) {
            aLinks.push(item.href)
          }
          setLinks(aLinks)
        }
      }
    }
  }, [data])

  useEffect(() => {
    if (links?.length > 0) {
      if (isGifLink) {
        setImageUrls(links)
      } else {
        if (apiKey) {
          axios
            .all(
              links.map((link) => {
                const encodedURL = encodeURIComponent(link)
                const url = `https://opengraph.io/api/1.1/site/${encodedURL}?accept_lang=auto&app_id=${apiKey}&use_proxy=true`
                return axios.get(url).catch((err) => {
                  console.error(`Error fetching metadata for ${link}: ${err.message}`)
                })
              })
            )
            .then((data) => {
              if (data && data.length > 0) {
                const linkImageUrls = []
                const linkDescriptions = []
                const linkTitles = []
                const linkSiteNames = []
                const linkVideos = []
                const linkVideoTypes = []
                const linkGifImages = []
                data.forEach((d, index) => {
                  if (!d && isGifUrl(links[index])) {
                    linkImageUrls.push(links[index])
                    linkGifImages.push(true)
                    linkDescriptions.push('')
                    linkTitles.push('')
                    linkSiteNames.push('')
                    linkVideos.push('')
                    linkVideoTypes.push('')
                  } else {
                    const metadata = d?.data?.hybridGraph
                    linkGifImages.push(false)
                    linkImageUrls.push(metadata?.image || metadata?.imageSecureUrl)
                    linkDescriptions.push(metadata?.description)
                    linkTitles.push(metadata?.title)
                    linkSiteNames.push(metadata?.site_name)
                    linkVideos.push(metadata?.video)
                    linkVideoTypes.push(metadata?.videoType)
                  }
                })
                setImageUrls(linkImageUrls)
                setDescriptions(linkDescriptions)
                setTitles(linkTitles)
                setSiteNames(linkSiteNames)
                setVideos(linkVideos)
                setVideoTypes(linkVideoTypes)
                setIsGifImages(linkGifImages)
              }
            })
          // .catch((e) => {
          //   setHasError(true)
          // })
        }
      }
    }
  }, [links])

  return (
    links &&
    links.length > 0 && (
      <div className={`${styles.previewContainer} ${containerCSS}`}>
        {!hasError ? (
          links.map((link, index) => {
            let image = imageUrls[index]
            let title = titles[index]
            let description = descriptions[index]
            let siteName = siteNames[index]
            const video = videos[index]
            const videoType = videoTypes[index]
            const isGifImage = isGifImages[index]
            if (link.includes('mixr.net')) {
              description = document.querySelector("meta[name='description']").getAttribute('content')
              image = `${config.assetUrl}/images/logo-mixr.png`
              title = 'MixR, build your communities @work'
              siteName = 'MixR'
            }
            if (!isGifLink && !image && !title && !description) {
              return null
            }

            const isVideoUrlAllowed =
              video && appConstantSettings.ALLOWED_VIDEO_URLS.some((vurl) => video.includes(vurl))
            const noMedia = !image && !video && !isVideoUrlAllowed
            const isDisabledWebsite = appConstantSettings.DISABLED_SITES.find((x) => link.includes(x))
            const noMeta = !(title || description || siteName)
            return !isDisabledWebsite ? (
              isGifLink || isGifImage ? (
                <img
                  className={`${styles.previewImage} ${styles.previewGif}`}
                  src={`${config.webUrl}/link_preview/image.php?url=${encodeURIComponent(image)}`}
                />
              ) : (
                <a
                  key={index}
                  className={`${styles.preview} ${fromQuickMessenger && styles.chatPreview} ${
                    isVideoUrlAllowed && styles.previewFull
                  } ${noMeta && styles.previewWithNoMeta} ${linkCSS}`}
                  href={link}
                  target='_blank'>
                  {isVideoUrlAllowed ? (
                    <iframe
                      className={`${styles.previewImage} ${styles.videoPreview} ${previewCSS}`}
                      src={video}></iframe>
                  ) : image ? (
                    <img
                      onError={(err) => {
                        //if there is an error in image, then do not display the image
                        err.target.style.display = 'none'
                        if (noMeta) {
                          err.target.parentElement.style.display = 'none'
                        }
                      }}
                      className={`${styles.previewImage} ${fromQuickMessenger && styles.chatPreviewImage} ${
                        noMeta && styles.imageWithNoMeta
                      } ${previewCSS}`}
                      alt={title}
                      src={`${config.webUrl}/link_preview/image.php?url=${encodeURIComponent(image)}`}
                    />
                  ) : null}
                  {!noMeta && (
                    <div
                      className={`${styles.metaContainer} ${isVideoUrlAllowed && styles.videoMetaContainer} ${
                        noMedia && styles.noMediaMetaContainer
                      }`}>
                      {title && <h1 className={styles.title}>{title}</h1>}
                      {description && (
                        <h2 className={styles.description}>
                          {description.length > 0 && image ? `${description.substring(0, 200)}...` : description}
                        </h2>
                      )}
                      {siteName && <p className={styles.hostname}>{siteName}</p>}
                    </div>
                  )}
                </a>
              )
            ) : null
          })
        ) : (
          <img
            onError={(e) => {
              e.target.src = null
              e.target.onerror = null
              setNotValidImage(true)
            }}
            className={`${styles.previewImage} ${styles.previewImageIfErrro} ${
              notValidImage && styles.hidePreview
            } ${linkCSS}`}
            src={`${config.webUrl}/link_preview/image.php?url=${encodeURIComponent(links[0])}`}
          />
        )}
      </div>
    )
  )
}
